import { C as Cart } from './cart-BPgrnoRc.js';
import { P as PubSub } from './pubsub-CoPYzvVm.js';
import './notyf-DIw0RvBj.js';
import './uniq-D7II7obF.js';

class QuickShop extends HTMLElement {
  #variants = JSON.parse(this.dataset.productVariants || '[]');
  #options = JSON.parse(this.dataset.productOptions || '[]');
  #selectedOptions = {};
  #addToCartButton = this.querySelector('.quickshop-add-to-cart');
  #optionSelects = this.querySelectorAll('.quickshop-option');
  #soldOutText = this.dataset.soldOutText || 'Sold out';
  #addToCartText = this.dataset.addToCartText || 'Add to cart';
  #buttonTextElement = this.#addToCartButton?.querySelector('.quickshop-button-text');
  #buttonIconElement = this.#addToCartButton?.querySelector('.icon');

  connectedCallback() {
    if (!this.#addToCartButton) return;

    this.#optionSelects.forEach((select) => {
      select.addEventListener('change', () => this.#updateOptions());
    });

    this.#addToCartButton.addEventListener('click', (e) => {
      e.stopPropagation();
      this.#handleAddToCart();
    });

    this.addEventListener('click', (e) => e.stopPropagation());
    this.#updateButtonState();
  }

  #updateOptions() {
    this.#optionSelects.forEach((select) => {
      const position = +select.dataset.optionPosition;
      select.value
        ? (this.#selectedOptions[position] = select.value)
        : delete this.#selectedOptions[position];
    });
    this.#updateButtonState();
  }

  #findVariant() {
    if (this.#optionSelects.length === 0) return this.#variants[0] || null;
    if (Object.keys(this.#selectedOptions).length !== this.#options.length) return null;
    return this.#variants.find((variant) =>
      this.#options.every(
        (option) => variant.options[option.position - 1] === this.#selectedOptions[option.position]
      )
    );
  }

  #updateButtonState() {
    const variant = this.#findVariant();
    if (this.#optionSelects.length === 0) {
      this.#addToCartButton.disabled = !variant?.available;
      this.#updateButtonText(!variant?.available);
      return;
    }
    const allSelected = this.#options.every(
      (option) => this.#selectedOptions[option.position] !== undefined
    );
    const isOutOfStock = allSelected && variant && !variant.available;
    this.#addToCartButton.disabled = !(allSelected && variant?.available);
    this.#updateButtonText(isOutOfStock);
  }

  #updateButtonText(isSoldOut) {
    if (!this.#buttonTextElement) return;
    this.#buttonTextElement.textContent = isSoldOut ? this.#soldOutText : this.#addToCartText;
    this.#buttonIconElement?.classList.toggle('hidden', isSoldOut);
  }

  async #handleAddToCart() {
    const variant = this.#findVariant();
    if (!variant?.available) return;

    this.#addToCartButton.disabled = true;
    this.#addToCartButton.classList.add('loading');

    try {
      await Cart.add({ items: [{ id: variant.id, quantity: 1 }] });
      PubSub.publish('dialog:open', { id: 'cart-drawer' });
    } catch (error) {
      console.error('Error adding to cart:', error);
    } finally {
      this.#addToCartButton.classList.remove('loading');
      this.#updateButtonState();
    }
  }
}

customElements.define('quick-shop', QuickShop);
